import "../css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./designSystem/Navbar";
import Footer from "./designSystem/Footer";
import ScrollToTop from "./designSystem/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import ContactUsPage from "./pages/ContactUsPage";
import MortgageBorrowCalculatorsPage from "../frontend/pages/calculators/MortgageBorrowPage";
import MortgageRepaymentCalculatorsPage from "../frontend/pages/calculators/MortgageRepaymentPage";
import MortgageOverpaymentCalculatorsPage from "../frontend/pages/calculators/OverpaymentPage";
import StampDutyPage from "../frontend/pages/calculators/StampDutyPage";
import HowMuchWillItCostPage from "../frontend/pages/calculators/HowMuchWillItCostPage";
import HowMuchCanIBorrowPage from "../frontend/pages/calculators/HowMuchCanIBorrowPage";
import EquityReleasePage from "../frontend/pages/calculators/EquityReleasePage";
import RelevantLifeTaxPage from "../frontend/pages/calculators/RelevantLifeTaxPage";
import PensionShortfallPage from "../frontend/pages/calculators/PensionShortfallPage";
import InheritanceTaxPage from "../frontend/pages/calculators/InheritanceTaxPage";
import InvestmentPage from "../frontend/pages/calculators/InvestmentPage";
import ContactUsComponent from "./components/ContactUsComponent";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="background-container">
          <Navbar />
          {/* Navbar can be added here if needed */}
          {/* Define application routes */}
         
            <Routes>
              {/* Home page route */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/*" element={<LandingPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              {/* <Route path="/contact-us" element={<ContactUsPage />} />
              <Route
                path="/calculators/mortgage-borrow"
                element={<MortgageBorrowCalculatorsPage />}
              />
              <Route
                path="/calculators/mortgage-repayment"
                element={<MortgageRepaymentCalculatorsPage />}
              />
              <Route
                path="/calculators/overpayment"
                element={<MortgageOverpaymentCalculatorsPage />}
              />
              <Route
                path="/calculators/stamp-duty"
                element={<StampDutyPage />}
              />
              <Route
                path="/calculators/how-much-will-it-cost"
                element={<HowMuchWillItCostPage />}
              />
              <Route
                path="/calculators/how-much-can-i-borrow"
                element={<HowMuchCanIBorrowPage />}
              />
              <Route
                path="/calculators/equity-release"
                element={<EquityReleasePage />}
              />
              <Route
                path="/calculators/relevant-life-tax"
                element={<RelevantLifeTaxPage />}
              />
              <Route
                path="/calculators/pensions-shortfall"
                element={<PensionShortfallPage />}
              />
              <Route
                path="/calculators/inheritance-tax"
                element={<InheritanceTaxPage />}
              />
              <Route
                path="/calculators/investment"
                element={<InvestmentPage />}
              /> */}
            </Routes>
            <ContactUsComponent />
            <Footer />
          </div>
    
      </Router>
    </HelmetProvider>
  );
}

export default App;
